var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.$page.props.flash.error && _vm.show)?_c('v-alert',{attrs:{"dense":"","outlined":"","type":"error"}},[_vm._v(" "+_vm._s(_vm.$page.props.flash.error)+" ")]):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }